module.exports = __webpack_public_path__ + "img/play-blanco.74df2a9a.svg";